const MINUTE = 60_000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

function plural(n: number, one: string, many: string): string {
  return `${n} ${n === 1 ? one : many}`;
}

export function formatUpdatedAgo(iso: string | undefined, now: Date): string {
  if (!iso) return '';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  const elapsed = Math.max(0, now.getTime() - date.getTime());
  if (elapsed < MINUTE) return 'Updated just now';
  if (elapsed < HOUR) return `Updated ${plural(Math.floor(elapsed / MINUTE), 'minute', 'minutes')} ago`;
  if (elapsed < DAY) return `Updated ${plural(Math.floor(elapsed / HOUR), 'hour', 'hours')} ago`;
  return `Updated ${plural(Math.floor(elapsed / DAY), 'day', 'days')} ago`;
}
